import _defineProperty from "/Users/felipe.ramirez/Documents/quattro/valve_inventory_crystin/valve_inventory_app_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/felipe.ramirez/Documents/quattro/valve_inventory_crystin/valve_inventory_app_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useStyleRegister } from '@ant-design/cssinjs';
import { resetIcon } from '../../style';
import useToken from '../useToken';
var useResetIconStyle = function useResetIconStyle(iconPrefixCls, csp) {
  var _useToken = useToken(),
    _useToken2 = _slicedToArray(_useToken, 2),
    theme = _useToken2[0],
    token = _useToken2[1]; // Generate style for icons
  return useStyleRegister({
    theme: theme,
    token: token,
    hashId: '',
    path: ['ant-design-icons', iconPrefixCls],
    nonce: function nonce() {
      return csp === null || csp === void 0 ? void 0 : csp.nonce;
    }
  }, function () {
    return [_defineProperty({}, ".".concat(iconPrefixCls), Object.assign(Object.assign({}, resetIcon()), _defineProperty({}, ".".concat(iconPrefixCls, " .").concat(iconPrefixCls, "-icon"), {
      display: 'block'
    })))];
  });
};
export default useResetIconStyle;